import { TProductCategory } from '@lib/core/products/types';
import { ENV_MEDIA_CONTENT_DOMAIN } from '@lib/core/service/consts';
import { history } from '@lib/core/service/utils/Navigator';

export const setUrlParams = (params: { key: string; value: string }[]) => {
  const {
    location: { pathname, search },
  } = window;
  const searchParams = new URLSearchParams(search);

  params.forEach(({ key, value }) => {
    if (value) {
      searchParams.set(key, value);
    } else {
      searchParams.delete(key);
    }
  });

  history.push(`${pathname}?${searchParams.toString()}`);
};

export const removeUrlParams = ({ keys }: { keys: string[] }) => {
  const {
    location: { pathname, search },
  } = window;
  const newSearchParams = new URLSearchParams(search);
  keys.forEach(key => {
    const currentParamValue = newSearchParams.get(key);
    if (currentParamValue) {
      newSearchParams.delete(key);
    }
  });
  const newSearchParamsString = newSearchParams.toString();
  if (newSearchParamsString) {
    history.push(`${pathname}?${newSearchParams.toString()}`);
  } else {
    history.push(pathname);
  }
};

/**
 * @param queryString - queryparams
 * @param queryKey - parameter to get value of
 * @returns value of the parameter
 */
export const getQueryValue = (queryString: string, queryKey: string) => {
  const params = new URLSearchParams(queryString);
  return params.get(queryKey);
};

export const getRandomIndex = (limitValue: number) => Math.floor(Math.random() * limitValue);

export const isVideoLink = url => {
  // Define an array of video file extensions
  const videoExtensions = ['.mp4', '.avi', '.mkv', '.mov', '.wmv', '.flv', '.webm'];

  // Get the file extension from the URL
  const fileExtension = url.split('.').pop().toLowerCase();

  // Check if the file extension is in the list of video extensions
  return videoExtensions.includes(`.${fileExtension}`);
};

const getProductCategoryImageUrl = (productCategory: TProductCategory, name: string) =>
  `${ENV_MEDIA_CONTENT_DOMAIN}/${productCategory}/${productCategory}_${name}`;

export const getProductPlaceholderImage = (c: TProductCategory) =>
  getProductCategoryImageUrl(c, 'missing_products_image.png');
export const getTasteTestImage = (c: TProductCategory) => getProductCategoryImageUrl(c, 'taste_test.png');
export const getPairingTestImage = (c: TProductCategory) => getProductCategoryImageUrl(c, 'pairing_test.png');
export const getExpertTestImage = (c: TProductCategory) => getProductCategoryImageUrl(c, 'expert_test.png');
export const getScanBarcodeImage = (c: TProductCategory) => getProductCategoryImageUrl(c, 'scan_barcode.png');
export const getMapExploreIcon = (c: TProductCategory) => getProductCategoryImageUrl(c, 'map_explore.svg');
export const getCurrentMapExploreIcon = (c: TProductCategory) =>
  getProductCategoryImageUrl(c, 'current_map_explore.svg');
export const getCharacterAdjectiveImage = (c: TProductCategory, score: 0 | 1 | 2 | 3 | 4 | 5) =>
  getProductCategoryImageUrl(c, `character_adjective_${score}.${score === 0 ? 'png' : 'gif'}`);
export const getEmptyPlacesImage = (c: TProductCategory) => getProductCategoryImageUrl(c, 'empty_places.png');
export const getEmptyProductsImage = (c: TProductCategory) => getProductCategoryImageUrl(c, 'empty_products.png');
export const getSavedPlaceImage = (c: TProductCategory) => getProductCategoryImageUrl(c, 'place_saved.png');
export const getSavedProductImage = (c: TProductCategory) => getProductCategoryImageUrl(c, 'product_saved.png');
export const getRatedProductImage = (c: TProductCategory, score: 4 | 5) =>
  getProductCategoryImageUrl(c, `product_rated_${score}.png`);
